module.exports = __webpack_public_path__ + "img/page7_coBranded_bac.af6b614a.png";